<template>
    <div class="page-award page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">会员等级管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
                            <el-breadcrumb-item>会员等级管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleAward('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <!-- <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button> -->
                </el-col>
            </el-row>
            <div class="bd">
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="name" align="center" label="会员等级名称" min-width="160">
                            </el-table-column>
                            <el-table-column prop="description" align="center" label="描述" min-width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.description"></my-textEllipsis>
                                </template>
                            </el-table-column>
							<el-table-column prop="order_discount" align="center" label="折扣率" min-width="160">
								<template slot-scope="scope">
								    <my-textEllipsis v-if="is_refresh" :content="(scope.row.order_discount * 100) + '%'"></my-textEllipsis>
								</template>
							</el-table-column>
                            <el-table-column prop="threshold_val" align="center" label="充值金额" min-width="120">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleAward('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteAward(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export award-dialog" :title="dlg_award.title" :visible.sync="dlg_award.visible" width="600px" @closed="closeAward" :close-on-click-modal="false">
            <el-form ref="formAward" :model="dlg_award.form" label-width="130px" :rules="dlg_award.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="会员等级名称：" :error="dlg_award.error.name">
                    <el-input size="small" v-model="dlg_award.form.name" placeholder='请输入会员等级名称' clearable></el-input>
                </el-form-item>
                <el-form-item prop="description" label="描述：" :error="dlg_award.error.description">
                    <el-input v-model="dlg_award.form.description" type="textarea" :rows="3" size="small" placeholder="请输入描述"></el-input>
                </el-form-item>
				<el-form-item prop="order_discount" label="扣率：" :error="dlg_award.error.order_discount">
				    <el-input size="small" type='number' v-model="dlg_award.form.order_discount" placeholder='请输入折扣率0~1之间' clearable></el-input>
				</el-form-item>
                <el-form-item prop="threshold_val" label="充值金额：" :error="dlg_award.error.threshold_val">
                    <el-input size="small" type='number' v-model="dlg_award.form.threshold_val" placeholder='请输入充值金额' clearable></el-input>
                </el-form-item>
				<el-form-item prop="status" label="状态：">
				    <el-radio-group v-model="dlg_award.form.status">
				        <el-radio v-for="(item, index) in dlg_award.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
				    </el-radio-group>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_award.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitAward()" :loading="dlg_award.btn_loading">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_award:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    form:{
                        name:'',
                        description:'',
						order_discount:'',
                        threshold_val:'',
						status: 1,
                    },
                    error:{
                        name:'',
                        description:'',
                        threshold_val:''
                    },
                    reset_form: {},
                    init_data:{
                        status_list: []
                    },
                    rules:{
                        name:{required: true, message: '请输入会员等级名称', trigger: ['change','blur']},
                        threshold_val:{required: true, message: '请输入充值金额', trigger: ['change','blur']}
                    }
                }
            }
        },
        created() {
            document.title = '会员等级管理';
            this.dlg_award.reset_form = Object.assign({}, this.dlg_award.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = {};
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/userviprule/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_award.init_data.status_list = res.status_name_list;
                    // _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的会员等级");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/userviprule/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleAward(type,data){
                this.dlg_award.visible = true;
                if(type == 'add'){
                    this.dlg_award.title = '添加会员等级';
                    this.dlg_award.api = '/adminapi/userviprule/save';
                }else{
                    this.dlg_award.id= data.id;
                    this.dlg_award.title = '编辑会员等级';
                    if(data){
                        for(var key in this.dlg_award.form){
                            this.dlg_award.form[key] = data[key];
                        }
                    }
                    this.dlg_award.api = '/adminapi/userviprule/save?id=' + data.id;
                }
            },
            deleteAward(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/userviprule/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitAward(){
                var _this = this;
                _this.$refs['formAward'].validate((valid) => {
                    if (valid) {
                        this.dlg_award.btn_loading = true;
                        this.$client.post(this.dlg_award.api, this.dlg_award.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_award.btn_loading = false;
                            _this.dlg_award.visible = false;
                        }, function(message){
                            console.log(message);
                            _this.dlg_award.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_award.error[key] = message[key];
                                    console.log(_this.dlg_award.error[key]);
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeAward(){
                for(var key in this.dlg_award.form){
                    this.dlg_award.form[key] = this.dlg_award.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formAward.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>

</style>
<style scoped>

</style>